/**
 * Client-side utility to resolve tool query configs to full GraphQL strings.
 * Uses the shared buildToolQueryString from @takeshape/graphql.
 */
import { buildToolQueryString, prettifyQuery } from '@takeshape/graphql';
import { ensureQuery, type ProjectSchemaJSON, type ToolQueryConfig, type ToolQueryRefConfig } from '@takeshape/schema';

export function convertRefToQueryString(schemaJson: ProjectSchemaJSON, refConfig: ToolQueryRefConfig): string {
  const { ref, selectionSet } = refConfig;
  const { name: queryName } = ensureQuery(schemaJson, ref);
  return prettifyQuery(buildToolQueryString(schemaJson, { queryRef: ref, queryName, selectionSet }));
}

export function resolveToolQuery(schemaJson: ProjectSchemaJSON, query: ToolQueryConfig): string {
  if (typeof query === 'string') {
    return query;
  }

  return convertRefToQueryString(schemaJson, query);
}
